__turbopack_context__.v({
  "sort": "SortControl-module-scss-module__6d0HKq__sort",
});
